import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { BreadcrumbAboutIsn, BannerAbout, RightMenu, MessageFromRepresentativeContent } from '../../common';
import CompanyOverviewImg from '../../../../assets/images/drew-beamer-Se7vVKzYxTI-unsplash.jpg';
import { getLanguage } from '../../../../utils/params';
import * as action from '../../aboutIsn.action';

const MessageFromRepresentativeComponent = props => {
  const { t } = useTranslation();
  const language = getLanguage(useLocation());

  const breadCrumb = [
    { title: t('about_isn.home'), url: '/' },
    { title: t('about_isn.about_isn'), url: '/mess-from-rep' },
    { title: t('about_isn.company_overview_page.mess_from_rep') },
  ];
  const banner = {
    img: CompanyOverviewImg,
    title: t('about_isn.company_overview_page.mess_from_rep'),
  };

  useEffect(() => {
    props.fetchAboutIsnRequest({ language, slug: 'mess-from-rep' });
    // window.scrollTo(0, 0);
    const scrollTo = document.querySelector('#position-scroll');
    if (scrollTo) {
      scrollTo.scrollIntoView({ behavior: 'smooth' });
    }
    //eslint-disable-next-line
  }, [language]);

  return (
    <>
      <BreadcrumbAboutIsn breadCrumb={breadCrumb} />
      <section className="profile-company group-company">
        <BannerAbout banner={banner} />
        <div id="position-scroll"></div>
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-9">
              <MessageFromRepresentativeContent />
            </div>
            <div className="col-12 col-md-3">
              <RightMenu />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ fetchAboutIsnRequest: action.fetchAboutIsnRequest }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MessageFromRepresentativeComponent);
